import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import { localBusinessSchema } from '../config/schema'

const sections = [
  ['Respectful behavior', 'Please treat independent professionals, staff, and other guests with courtesy. Harassment, discrimination, aggressive conduct, property damage, or behavior that creates an unsafe environment may result in service being refused.'],
  ['Guests and children', 'Please limit additional guests and arrange childcare whenever possible. Children must remain supervised and may not climb, run, or play on salon equipment.'],
  ['Pets and service animals', 'Pets cannot enter the salon environment. Trained service animals are welcome in accordance with applicable law.'],
  ['Mobile devices', 'Keep devices on silent or vibrate. Please avoid speakerphone and video calls inside the salon. Step outside when a call could interrupt other guests.'],
  ['Cancellations and rescheduling', 'Each independent provider sets their own cancellation policy. Contact your provider as early as possible if you need to change an appointment. Late cancellations and missed appointments may be charged.'],
  ['Arrival times', 'Contact your provider if you expect to arrive late. A late arrival may shorten the service or require rescheduling.'],
  ['Health and well-being', 'Tell your provider about relevant allergies, pregnancy, nursing, medical conditions, or physical limitations. Reschedule if you have a communicable illness or an open wound that could affect safe service.'],
  ['Service concerns', 'Contact your provider promptly if you have a concern. Independent professionals will explain their individual adjustment, refund, or follow-up policies.'],
]

export default function SalonEtiquette() {
  return (
    <>
      <SEO page="etiquette" structuredData={localBusinessSchema} />
      <PageHero index="08" eyebrow="Guest information" title="Salon etiquette" description="Simple guidelines that help every guest enjoy a calm, professional visit." image="Home-banner-slider.webp" />
      <section className="section section--soft">
        <div className="container legal-page">
          <p className="legal-intro">Diamond Suites Ocala is home to independent beauty and wellness businesses. These shared-space guidelines support safety, comfort, and respect throughout the building.</p>
          {sections.map(([title, text], index) => (
            <section key={title}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <div><h2>{title}</h2><p>{text}</p></div>
            </section>
          ))}
          <p className="legal-note">Appointment-specific policies are set by each independent provider. Contact your provider directly for details.</p>
        </div>
      </section>
    </>
  )
}
